import QRCode from "qrcode";

import { KEEPO_SYMBOL_BAR, KEEPO_SYMBOL_CHEVRON } from "../../components/KeepoLoader";

// Keepo's K over the middle: as big as on a box of 28% of the code, with half that box's white around it (a square
// of ~22%). Read by every one of 200 random paths from 150px up; H, the most error correction, keeps it readable.
const SYMBOL = 0.28 * 0.56;
const BREATH = 0.28 * 0.11;

/** The QR code of a short link, as SVG: Keepo's K in the middle, on a square white box. */
export const qrSvg = async (url: string): Promise<string> => {
  const svg = await QRCode.toString(url, { type: "svg", margin: 2, width: 1024, errorCorrectionLevel: "H" });
  const side = Number(svg.match(/viewBox="0 0 (\d+) \d+"/)?.[1] ?? 0);
  const symbol = side * SYMBOL;
  const box = symbol + 2 * side * BREATH;
  const boxAt = (side - box) / 2;
  const symbolAt = (side - symbol) / 2;
  const mark =
    `<rect class="keepo-mark" x="${boxAt}" y="${boxAt}" width="${box}" height="${box}" fill="#ffffff"/>` +
    `<g transform="translate(${symbolAt} ${symbolAt}) scale(${symbol / 100})" fill="#000000">` +
    `<path d="${KEEPO_SYMBOL_BAR}"/><path d="${KEEPO_SYMBOL_CHEVRON}"/></g>`;
  return svg.replace("</svg>", `${mark}</svg>`);
};

/** The SVG drawn as a PNG of `size` px (to print), as a data URL. */
export const qrPng = (svg: string, size = 1024): Promise<string> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = canvas.height = size;
      const context = canvas.getContext("2d");
      if (!context) {
        reject(new Error("No canvas"));
        return;
      }
      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, size, size);
      context.drawImage(image, 0, 0, size, size);
      resolve(canvas.toDataURL("image/png"));
    };
    image.onerror = () => reject(new Error("The QR code could not be drawn"));
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  });
